import BookingForm from "./BookingForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

export default function AppointmentDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] max-w-[950px] overflow-y-auto rounded-[18px] border-0 bg-white p-6 shadow-[0_24px_80px_rgba(6,56,111,0.25)] sm:p-8">
        <DialogHeader className="pr-8 text-left">
          <DialogTitle className="text-[32px] font-extrabold leading-tight text-[#071746] sm:text-[42px]">
            Reserve Your Smile
          </DialogTitle>
          <DialogDescription className="text-[15px] text-paradise-slate sm:text-[18px]">
            Complete the form below to book your appointment with our specialized dental team.
          </DialogDescription>
        </DialogHeader>
        <BookingForm variant="popup" />
      </DialogContent>
    </Dialog>
  );
}
